import { get, joinTextSpans } from '../../utils/object-helpers';

export default function Cart() {}

Cart.build = function(addToCartResp, defaultErrorMessage) {
    if (addToCartResp) {
        const atc = get(addToCartResp, 'modules.ADDTOCART', null);
        const heading = get(atc, 'header', '');
        const summary = get(atc, 'itemSummary', null);
        const prices = [];
        const actions = get(summary, 'actions', []);
        const primaryBtn = actions.find(action => action.type === 'PRIMARY');
        const secondaryBtn = actions.find(action => action.type === 'SECONDARY');

        const helpfulTexts = get(summary, 'helpfulTexts.approx.textSpans.0.text', '');
        const displayPriceText = get(summary, 'displayPrice.textSpans.0.text', '');
        const displayPriceStyle = get(summary, 'displayPrice.textSpans.0.styles.0', '');
        const price = `${helpfulTexts} ${displayPriceText}`;
        prices.push({
            value: {
                text: price,
                style: displayPriceStyle
            }
        });

        const convertedPrice = get(summary, 'convertedPrice.textSpans.0.text', '');
        if (convertedPrice) {
            prices.push({
                value: {
                    text: `(${convertedPrice})`,
                    style: 'SECONDARY'
                }
            });
        }

        // SME
        let sme;
        const smeContent = get(summary, 'sme', []);
        if (smeContent.length) {
            const smeTitle = joinTextSpans(smeContent[0], 'textSpans');
            const smeMessages = [];
            for (let i = 1, n = smeContent.length; i < n; i++) {
                const content = smeContent[i];
                smeMessages.push({
                    text: joinTextSpans(content, 'textSpans'),
                    url: get(content, 'action.URL', '')
                });
            }
            if (smeTitle) {
                sme = { title: smeTitle };
                if (smeMessages.length) {
                    sme.messages = smeMessages;
                }
            }
        }

        // Error
        let error;
        const errorMessages = get(atc, 'errorMessage.pageMessage.textSpans', []);
        if (errorMessages.length) {
            error = { title: heading };
            error.messages = [];
            errorMessages.forEach(msg => {
                error.messages.push(msg.text);
            });
        } else if (!atc) {
            error.messages = [defaultErrorMessage];
        }

        return {
            heading,
            imageUrl: get(summary, 'image.URL', 'https://p.ebaystatic.com/aw/pics/cmp/icn/iconImgNA_96x96.gif'),
            title: joinTextSpans(summary, 'title.textSpans'),
            mskuSummary: joinTextSpans(summary, 'mskuSummary.textSpans', ''),
            prices,
            quantity: joinTextSpans(summary, 'quantity.textSpans', ''),
            taxDisclaimer: joinTextSpans(summary, 'taxDisclaimer.textSpans'),
            sme,
            primaryButton: {
                text: get(primaryBtn, 'textSpans.0.text', ''),
                url: get(primaryBtn, 'action.URL', ''),
                tracking: JSON.stringify(get(primaryBtn, 'action.tracking', ''))
            },
            secondaryButton: {
                text: get(secondaryBtn, 'textSpans.0.text', ''),
                url: get(secondaryBtn, 'action.URL', ''),
                tracking: JSON.stringify(get(secondaryBtn, 'action.tracking', ''))
            },
            error
        };
    }
};
